import React from 'react';
import { withTranslation } from "react-i18next";
import Loading from "./Loading";
import { Modal } from 'react-bootstrap';
import NumberFormat from "react-number-format";
import EmbeddedPdf from "./EmbeddedPdf";
import { commaValue } from "../../../helpers";

function ContractPreview(props) {

    let number = function (value) {
        return(
            <NumberFormat
                thousandSeparator={'.'}
                decimalSeparator={','}
                displayType={"text"}
                fixedDecimalScale={true}
                decimalScale={2}
                value={value}
            />
        );
    }

    let showPdfUrl = function () {
        return (
            '/api/process/'
            + props.application_token
            + '/show_schedule?term='
            + props.deal.deals.term
            + '&amount='
            + props.deal.deals.financed_amount
        );
    }

    let downloadPdfUrl = function () {
        return (
            '/api/process/'
            + props.application_token
            + '/download_schedule?term='
            + props.deal.deals.term
            + '&amount='
            + props.deal.deals.financed_amount
        );
    }

    return (
        <div>
            <Modal className="modal modal--big fade p-md-5"
                   dialogClassName="modal-dialog"
                   id="contract-preview"
                   show={props.is_preview_modal_shown}
                   onHide={props.hidePreviewModal}
            >
                    <div className="modal-content p-0">
                        <div className="modal-body p-0">
                            <h4 className="modal__heading p-5">{props.t('financial_clauses')}</h4>
                            <div className="container">
                                {(props.deal === null || props.application === null)
                                    ? <Loading
                                        msg={ props.t('info_about_loan_is_being_prepared') }
                                    />
                                    : <>
                                        <div className="row py-5 border-top border-gray-cloud">
                                            <div className="col-12 col-md-4">
                                                <p>Paskolos suma: <span className="text-primary"> {number(props.deal.deals.financed_amount)} {props.t('currency')}</span></p>
                                                {props.application.emodule !== null && props.application.emodule.order_id &&
                                                    <p>Pradinis įnašas: <span
                                                        className="text-primary"> {number(props.deal.deals.advance_amount)} {props.t('currency')}</span>
                                                    </p>
                                                }
                                                <p>Sutarties terminas: <span className="text-primary"> {props.deal.deals.term} {props.t('forms.months_short')}</span></p>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <p>Bendras pabrangimas: <span className="text-primary"> {number(props.deal.deals.detail.markup_amount)} {props.t('currency')}</span></p>
                                                <p className="text-smaller">Sutarties mokesčio įmokų suma: {number(props.deal.deals.detail.fee)} {props.t('currency')}</p>
                                                <p className="text-smaller">Palūkanų įmokų suma: {number(props.deal.deals.detail.int)} {props.t('currency')}</p>
                                            </div>
                                            <div className="col-12 col-md-4">
                                                <p>
                                                    Metinė palūkanų norma: <span className="text-primary"> {props.deal.deals.detail.intratetype == 'V' ? commaValue(props.deal.deals.detail.intrate, true) : number(props.deal.deals.detail.intratefixed)} %</span>
                                                </p>
                                                {props.deal.deals.detail.intratetype == 'V' &&
                                                        <p>
                                                            <span className="text-primary">{commaValue(props.deal.deals.detail.intratefixed, true)} % + {props.deal.deals.detail.ibor_string} ({commaValue(props.deal.deals.detail.ibor_rate_current_yearly, true)} %)</span>
                                                        </p>
                                                }
                                                <p>BVKKMN: <span className="text-primary"> {number(props.deal.deals.apr * 100)} %</span></p>
                                                <p>Delspinigių norma: <span className="text-primary"> {number(props.deal.deals.penalty_rate * 100)} %</span></p>
                                            </div>
                                        </div>
                                        <div className="col-12 mt-4">
                                            <div className="embed-document">
                                                <EmbeddedPdf src={showPdfUrl()}/>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="modal-footer py-5 d-flex justify-content-center">
                            {(props.deal !== null && props.application !== null)
                                ? <div>
                                    <button className="btn btn-lg btn-primary"
                                            onClick={()=> {
                                                props.showSif({
                                                    term: props.deal.deals.term,
                                                    amount: props.deal.deals.financed_amount
                                                })
                                            }}
                                    >
                                        Supratau, noriu sudaryti sutartį
                                    </button>
                                    <div className="text-center">
                                        <a href={downloadPdfUrl()} target="_blank">
                                            <i className="icons icon-file-download"></i>Parsisiųsti pdf
                                        </a>
                                    </div>
                                </div>
                                : ''
                            }
                        </div>
                    </div>
            </Modal>
        </div>
    );
}

export default withTranslation()(ContractPreview);
